import React, { useState, useEffect } from 'react';
import { Button, IconButton, Modal, TextField } from '@material-ui/core';
import { X } from 'tabler-icons-react';

/**
 * Modal de alta/edición para los catálogos de Calidad.
 * `item` en null significa alta; con item se edita y el código se muestra bloqueado.
 */
export default function ItemModal({ open, onClose, onSubmit, titulo, item, errorMsg }) {
    const [nombre, setNombre] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (open) {
            setNombre(item?.nombre || '');
            setError('');
        }
    }, [open, item]);

    const handleSubmit = () => {
        if (!nombre.trim()) {
            setError('El nombre es requerido');
            return;
        }
        onSubmit(nombre.trim());
    };

    return (
        <Modal open={open} onClose={onClose}>
            <div className="llamada-modal">
                <div className="llamada-modal-header">
                    <h2 className="popuptitle">{titulo}</h2>
                    <IconButton size="small" onClick={onClose}>
                        <X size={20} />
                    </IconButton>
                </div>
                <div className="llamada-modal-body">
                    {item && (
                        <div className="llamada-step-field">
                            <TextField label="Código" value={item.codigo ?? ''} fullWidth disabled />
                        </div>
                    )}
                    <div className="llamada-step-field">
                        <TextField
                            label="Nombre"
                            value={nombre}
                            onChange={(e) => {
                                setNombre(e.target.value);
                                if (error) setError('');
                            }}
                            fullWidth
                            autoFocus
                            error={!!error}
                            helperText={error}
                            inputProps={{ maxLength: 80 }}
                        />
                    </div>
                </div>
                {errorMsg && <p className="llamada-modal-error">{errorMsg}</p>}
                <div className="llamada-modal-footer">
                    <Button variant="outlined" color="primary" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                        {item ? 'Guardar cambios' : 'Guardar'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
